export { default } from "./DialogTitle.js";
export { default as dialogTitleClasses } from "./dialogTitleClasses.js";
export * from "./dialogTitleClasses.js";